import { Entity } from '@data-client/rest';
class QRStatusEntity extends Entity {
    constructor() {
        super(...arguments);
        this.verified = false;
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
QRStatusEntity.key = 'QRStatus';
export { QRStatusEntity };
